import { IPublicationsReportRecord } from "../../../model/report/PublicationsReportRecord";
import { DateService } from "../../../service/DateService";
import PublicationsReportReportPresentationModel, {
  TPublicationReportReportPresentationModel
} from "./PublicationsReportReportPresentationModel";

export interface TPublicationsReportReportingPeriodPresentationModel {
  reportingPeriodId: number;
  reportingPeriodName: string;
  additionalEvaluationIndicator: boolean;
  additionalEvaluationStatus: string;
  additionalEvaluationDate: string;
  reports: TPublicationReportReportPresentationModel[];
}

const PublicationsReportReportingPeriodPresentationModel = (
  publicationReportRecords: IPublicationsReportRecord[]
): TPublicationsReportReportingPeriodPresentationModel => {
  let reportingPeriod = {} as TPublicationsReportReportingPeriodPresentationModel;

  if (publicationReportRecords && publicationReportRecords.length > 0) {
    reportingPeriod = {
      reportingPeriodId: publicationReportRecords[0].reportingPeriodId,
      reportingPeriodName: publicationReportRecords[0].reportingPeriodName,
      additionalEvaluationIndicator:
        publicationReportRecords[0].additionalEvaluationIndicator,
      additionalEvaluationStatus:
        publicationReportRecords[0].additionalEvaluationStatus,
      additionalEvaluationDate: publicationReportRecords[0]
        .additionalEvaluationDate
        ? DateService().formatDate(
            publicationReportRecords[0].additionalEvaluationDate
          )
        : "",
      reports: [] as TPublicationReportReportPresentationModel[]
    };

    reportingPeriod.reports = publicationReportRecords.map(
      (publicationReportRecord) => {
        return PublicationsReportReportPresentationModel(
          publicationReportRecord
        );
      }
    );
  }
  return reportingPeriod;
};

export default PublicationsReportReportingPeriodPresentationModel;
